import { gql } from 'apollo-angular';

export const fetchInvestisseurFileDataQuery = gql`
  query investisseurById($id: Long!) {
    investisseurById(id: $id) {
      id
      code
      ppeBackOffice
      gdaBackOffice
      investisseurEntite {
        displayName
      }
      filesMetadata {
        actif
        extension
        fileId
        versionNumber
        documentIdentifier
        denomination
        typeDocumentCode
        etatSignature
        dateDeDerniereModification
        fileName
        typeLibelle
        extension
        investisseurId
        investisseurIds
        tags
      }
    }
  }
`;
